export const LINE_WIDTH = 340;
